var _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons-buttom",
    clipPath: "url(#clip0_314_2157)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M39.9992 18.8656V21.2151C39.9753 21.341 39.9484 21.4639 39.9305 21.5898C39.7811 22.5817 39.7124 23.5947 39.4673 24.5597C37.6145 31.8393 33.105 36.6883 26.0373 39.1278C24.8928 39.5234 23.6795 39.7092 22.4662 39.9999V24.2091H27.2506C27.4927 22.333 27.7288 20.5019 27.9738 18.6168H22.4602C22.4602 17.2232 22.4393 15.8806 22.4722 14.541C22.4811 14.1634 22.5947 13.7618 22.7591 13.4171C23.1207 12.6619 23.8319 12.4162 24.5999 12.3772C25.6399 12.3263 26.6799 12.3382 27.7198 12.3203C27.8573 12.3203 27.9948 12.3053 28.1532 12.2993C28.1532 10.6899 28.1591 9.12554 28.1412 7.56114C28.1412 7.46823 27.9679 7.3034 27.8722 7.30041C26.3003 7.22848 24.7254 7.1086 23.1565 7.14457C21.6324 7.17753 20.2189 7.67502 19.0295 8.68499C17.4905 9.99165 16.827 11.7269 16.7254 13.6839C16.6477 15.1673 16.6836 16.6568 16.6687 18.1463C16.6687 18.2991 16.6687 18.449 16.6687 18.6468H11.8842V24.248H16.6447V39.7721C16.5461 39.7631 16.4714 39.7601 16.3967 39.7451C13.2081 39.1488 10.3302 37.8541 7.76615 35.8611C4.70601 33.4816 2.49756 30.4637 1.1976 26.8134C-0.505799 22.0243 -0.386262 17.2472 1.4815 12.5181C4.33843 5.27748 11.5166 0.239644 19.2775 0.00888052C22.8786 -0.096012 26.2973 0.632242 29.4471 2.38544C35.0564 5.50824 38.4901 10.2494 39.6885 16.5909C39.8289 17.3431 39.8976 18.1073 39.9992 18.8685V18.8656Z",
    fill: "#A29BF6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_314_2157"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.ab4b51489b4f384043a5428561f8bf9b.svg";
export { ForwardRef as ReactComponent };